// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1ZNS80wQSSbmDa-uhyl4Mp","icon":"_2JhUQu-xM5kC8IpmyARWkY","active":"_2fL05gaCb_uxPWesjz70Ri"};